import { useEffect } from "react";
import { WifiOff } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { flushOffline, useOnline } from "@/lib/offline";

export function OfflineBar() {
  const online = useOnline();
  useEffect(() => { if (online) flushOffline(api); }, [online]);
  useEffect(() => {
    const t = () => toast.success("Back online — your progress is synced");
    window.addEventListener("online", t);
    return () => window.removeEventListener("online", t);
  }, []);
  if (online) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[200] flex justify-center pointer-events-none" data-testid="offline-bar">
      <div className="mt-2 px-4 py-1.5 rounded-full bg-amber-400 text-black text-xs font-black flex items-center gap-2 shadow-lg pointer-events-auto">
        <WifiOff className="w-3.5 h-3.5" /> You're offline — apps you've opened before still work. We'll sync when you're back.
      </div>
    </div>
  );
}
